import { render } from "./elem-operating.vue?vue&type=template&id=48a3886c&ts=true"
import script from "./elem-operating.vue?vue&type=script&lang=ts"
export * from "./elem-operating.vue?vue&type=script&lang=ts"

import "./elem-operating.vue?vue&type=style&index=0&id=48a3886c&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__